import React, {useEffect, useState} from 'react'
import {toAbsoluteUrl} from '../../../../../../_metronic/helpers'
import '../../../Style/Style.css'

import {useThemeMode} from '../../../../../../_metronic/partials'
import {useNavigate} from 'react-router-dom'

import * as Yup from 'yup'
import {useFormik} from 'formik'
import {DataPruebaVehiculo} from '../../../../accounts/components/settings/SettingsModel'
import {ContactenosModel, RegistroEstatus, RegistroOrgVentas} from '../../../models/_models'
import Swal from 'sweetalert2'
import {createContactenos, findAllEstatus, findAllOrgVentas} from '../../../models/_requests'
import {useIntl} from 'react-intl'
import {useAuth} from '../../../../auth'

const initialValues: ContactenosModel = {
  Nombres: '',
  Apellidos: '',
  Celular: '',
  Email: '',
  Mensaje: '',
  IdEstatus: 0,
  IdOrgV: '',
  Activo: false,
}
const contactenosSchema = Yup.object().shape({
  Nombres: Yup.string()

    .max(50, 'Maximo 50 caracteres')
    .required('nombre es requerido'),
  Apellidos: Yup.string()

    .max(240, 'Maximo 240 caracteres')
    .required('apellido es requerido'),
  // Celular: Yup.string()
  //   .matches(/^\d+$/, 'Phone number must contain only numbers')
  //   .matches(/^9/, 'Phone number must start with 9')
  //   .matches(/^\d{9}$/, 'The phone number must be 9 digits')
  //   .max(9, 'Maximo 9 numbers')
  //   .required('celular es requerido'),
  // Email: Yup.string().email('Wrong email format').required('email es requerido'),
  Celular: Yup.string()
    .matches(/^\d+$/, 'El celular debe contener solo dígitos') // Asegura que sean solo dígitos
    .max(12, 'El celular debe tener como máximo 12 dígitos') // Permite un máximo de 12 caracteres
    .required('Celular es requerido'),
  Email: Yup.string()
    .email('Debe ser un Email válido') // Valida que sea un email correcto
    .required('Email es requerido'),
  Mensaje: Yup.string()

    .max(240, 'Maximo 240 caracteres')
    .required('mensaje es requerido'),
  IdEstatus: Yup.number().moreThan(0, 'estatus es requerido').required('estatus es requerido'),
  Activo: Yup.boolean().required('activo es requerido'),
})

const CreateContactenos: React.FC = () => {
  const {mode} = useThemeMode()
  const navigate = useNavigate()
  const {currentUser} = useAuth()
  const intl = useIntl()

  const [estado, setEstado] = useState<boolean>(false)
  const [loading, setLoading] = useState(false)
  const [loadingButton, setLoadingButton] = useState(false)

  const [dataEstatus, setDataEstatus] = useState<RegistroEstatus[]>([])

  const getDataEstatus = async () => {
    const value = {
      cantidad_max: '0',
      Language: intl.locale.toUpperCase(),
      filters: [
        {
          campo: 'IdEsquemaEstatus',
          operador: 'EQ',
          tipo: 'string',
          valor1: '2',
          valor2: '',
        },
      ],
    }

    try {
      const {data: list} = await findAllEstatus(value)
      if (list.message.msgId == 0) {
        setDataEstatus(list.registro)
      } else {
        setDataEstatus([])
      }
    } catch (error) {
      console.error(error)
    }
  }

  const [dataOrgVentas, setDataOrgVentas] = useState<RegistroOrgVentas[]>([])

  const getDataOrgVentas = async () => {
    const value = {
      cantidad_max: '0',
      Language: intl.locale.toUpperCase(),
      filters: [
        {
          campo: 'IdOrgSaas',
          operador: 'EQ',
          tipo: 'numeric2',
          valor1: currentUser ? currentUser.registro.IdOrgSaas.toString() : '',
          valor2: '',
        },
      ],
    }

    try {
      const {data: list} = await findAllOrgVentas(
        value,
        currentUser ? currentUser.registro.IdOrgV : '',
        currentUser ? currentUser.registro.IdRol : ''
      )
      if (list.message.msgId == 0) {
        setDataOrgVentas(list.registro)
      } else {
        setDataOrgVentas([])
      }
    } catch (error) {
      console.error(error)
    }
  }

  const formik = useFormik({
    initialValues: {
      Nombres: '',
      Apellidos: '',
      Celular: '',
      Email: '',
      Mensaje: '',
      IdEstatus: 0,
      IdOrgV: currentUser ? currentUser.registro.IdOrgV : '',
      Activo: false,
    },
    validationSchema: contactenosSchema,
    onSubmit: async (values, {setStatus, setSubmitting}) => {
      setLoadingButton(true)
      setLoading(true)

      try {
        const {data: create} = await createContactenos(
          values.Nombres,
          values.Apellidos,
          values.Mensaje,
          values.Celular,
          values.Email,
          Number(values.IdEstatus),
          values.IdOrgV,
          values.Activo
        )

        if (create.message.msgId == 0) {
          Swal.fire({
            icon: 'success',
            title: 'Creado!',
            text: `${create.message.msgTxt}`,

            showConfirmButton: false,
            timer: 3000,
          })

          setTimeout(() => {
            const direccion = `/menu/administracion/contactenos/view`
            navigate(direccion, {
              state: {
                id_contactenos: create.registro.IdContactenos,
              },
            })
          }, 1000)
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Oops... Ocurrio un error',
            text: `${create.message.msgTxt}`,

            showConfirmButton: false,
            timer: 3000,
          })
        }
      } catch (error) {
        console.error(error)

        setSubmitting(false)
        setLoading(false)
      }

      setLoadingButton(false)
    },
  })

  const handleCancelar = () => {
    setEstado(false)

    setTimeout(() => {
      const direccion = `/menu/administracion/contactenos`
      navigate(direccion)
    }, 1000)
  }

  useEffect(() => {
    getDataEstatus()
    getDataOrgVentas()
  }, [])

  return (
    <div className={'card'}>
      <form
        onSubmit={formik.handleSubmit}
        noValidate
        className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
      >
        <div className='row g-2 g-xl-8 '>
          <div className='col-xl-12 '>
            <div className='card-body d-flex flex-column  pt-3 mt-15 pb-0'>
              <h3 className='card-title fs-1  flex-column text-center'>{intl.formatMessage({id: 'CONTACTUS_DATA'})}</h3>

              <div className='row mb-1'>
                <div className='col-lg-4'>
                  <label className='col-lg-12 col-form-label fw-bold fs-6'>Nombres</label>

                  <div className='col-lg-12 fv-row'>
                    <input
                      type='text'
                      className={`form-control  ${
                        mode === 'dark' ? 'form-control-dark' : 'form-control-light'
                      } `}
                      placeholder='Nombres'
                      {...formik.getFieldProps('Nombres')}
                    />
                    {formik.touched.Nombres && formik.errors.Nombres && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block fw-bold  mx-3'>{formik.errors.Nombres}</div>
                      </div>
                    )}
                  </div>
                </div>

                <div className='col-lg-4'>
                  <label className='col-lg-12 col-form-label fw-bold fs-6'>Apellidos</label>

                  <div className='col-lg-12 fv-row'>
                    <input
                      type='text'
                      className={`form-control  ${
                        mode === 'dark' ? 'form-control-dark' : 'form-control-light'
                      } `}
                      placeholder='Apellidos'
                      {...formik.getFieldProps('Apellidos')}
                    />
                    {formik.touched.Apellidos && formik.errors.Apellidos && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block fw-bold  mx-3'>{formik.errors.Apellidos}</div>
                      </div>
                    )}
                  </div>
                </div>

                <div className='col-lg-4'>
                  <label className='col-lg-12 col-form-label fw-bold fs-6'>Celular</label>

                  <div className='col-lg-12 fv-row'>
                    <input
                      type='tel'
                      className={`form-control  ${
                        mode === 'dark' ? 'form-control-dark' : 'form-control-light'
                      } `}
                      placeholder='Celular'
                      {...formik.getFieldProps('Celular')}
                    />
                    {formik.touched.Celular && formik.errors.Celular && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block fw-bold  mx-3'>{formik.errors.Celular}</div>
                      </div>
                    )}
                  </div>
                </div>

                <div className='col-lg-4'>
                  <label className='col-lg-12 col-form-label fw-bold fs-6'>Email</label>

                  <div className='col-lg-12 fv-row'>
                    <input
                      type='email'
                      className={`form-control  ${
                        mode === 'dark' ? 'form-control-dark' : 'form-control-light'
                      } `}
                      placeholder='Email'
                      {...formik.getFieldProps('Email')}
                    />
                    {formik.touched.Email && formik.errors.Email && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block fw-bold  mx-3'>{formik.errors.Email}</div>
                      </div>
                    )}
                  </div>
                </div>

                <div className='col-lg-8'>
                  <label className='col-lg-12 col-form-label fw-bold fs-6'>Mensaje</label>

                  <div className='col-lg-12 fv-row'>
                    <input
                      type='text'
                      className={`form-control  ${
                        mode === 'dark' ? 'form-control-dark' : 'form-control-light'
                      } `}
                      placeholder='Mensaje'
                      {...formik.getFieldProps('Mensaje')}
                    />
                    {formik.touched.Mensaje && formik.errors.Mensaje && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block fw-bold  mx-3'>{formik.errors.Mensaje}</div>
                      </div>
                    )}
                  </div>
                </div>

                <div className='col-lg-4'>
                  <label className='col-lg-12 col-form-label fw-bold fs-6'>Estatus</label>

                  <div className='col-lg-12 fv-row'>
                    <select
                      className={`form-select  ${
                        mode === 'dark' ? 'form-control-dark' : 'form-control-light'
                      } `}
                      {...formik.getFieldProps('IdEstatus')}
                    >
                      <option value={''}>Seleccione estatus...</option>
                      {dataEstatus.map((option) => (
                        <option key={option.IdEstatus} value={option.IdEstatus}>
                          {option.Descripcion}
                        </option>
                      ))}
                    </select>
                    {formik.touched.IdEstatus && formik.errors.IdEstatus && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block fw-bold  mx-3'>{formik.errors.IdEstatus}</div>
                      </div>
                    )}
                  </div>
                </div>

                <div className='col-lg-4'>
                  <label className='col-lg-12 col-form-label fw-bold fs-6'>
                    <span className=''>Organización Ventas</span>
                  </label>

                  <div className='col-lg-12 fv-row'>
                    <select
                      className={`form-select  ${
                        mode === 'dark' ? 'form-control-dark' : 'form-control-light'
                      } `}
                      {...formik.getFieldProps('IdOrgV')}
                      disabled={true}
                    >
                      <option value=''>Seleccione org ventas...</option>
                      {dataOrgVentas.map((option) => (
                        <option key={option.IdOrgV} value={option.IdOrgV}>
                          {option.Descripcion}
                        </option>
                      ))}
                    </select>
                    {formik.touched.IdOrgV && formik.errors.IdOrgV && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block fw-bold  mx-3'>{formik.errors.IdOrgV}</div>
                      </div>
                    )}
                  </div>
                </div>

                <div className='col-lg-4'>
                  <label className='col-lg-12 col-form-label fw-bold fs-6'>Activo</label>

                  <div className='col-lg-12 fv-row'>
                    <select
                      className={`form-select  ${
                        mode === 'dark' ? 'form-control-dark' : 'form-control-light'
                      } `}
                      value={formik.values.Activo ? 'Si' : 'No'}
                      onChange={(e) => {
                        formik.setFieldValue('Activo', e.target.value === 'Si' ? true : false)
                      }}
                    >
                      <option value={'Si'}>Si</option>
                      <option value={'No'}>No</option>
                    </select>
                    {formik.touched.Activo && formik.errors.Activo && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block fw-bold  mx-3'>{formik.errors.Activo}</div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='row  my-5 me-1'>
          <div className='d-flex justify-content-end'>
            <button
              type='button'
              className='btn btn-secondary px-10 me-2 '
              onClick={handleCancelar}
            >
              Cancelar
            </button>
            <button
              type='submit'
              className='btn btn-primary px-10 '
              disabled={formik.isSubmitting || !formik.isValid}
            >
              {!loadingButton && 'Crear'}
              {loadingButton && (
                <span className='indicator-progress' style={{display: 'block'}}>
                  Espere por favor...{' '}
                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                </span>
              )}
            </button>
          </div>
        </div>
      </form>
    </div>
  )
}

export {CreateContactenos}
